interface Props {
  disabled?: boolean;
}
const SvgMinus: React.FC<Props> = ({ disabled = false }) => {
  return (
    <svg
      style={{ cursor: disabled ? "not-allowed" : "pointer" }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M1.99999 5.2C1.89398 5.1985 1.78873 5.21809 1.69036 5.25762C1.59198 5.29715 1.50245 5.35584 1.42695 5.43027C1.35146 5.50471 1.29151 5.59341 1.25059 5.69121C1.20967 5.78902 1.1886 5.89398 1.1886 6C1.1886 6.10602 1.20967 6.21098 1.25059 6.30879C1.29151 6.40659 1.35146 6.49529 1.42695 6.56973C1.50245 6.64416 1.59198 6.70285 1.69036 6.74238C1.78873 6.78192 1.89398 6.8015 1.99999 6.8C6.67119 6.8 4.82974 6.8 9.99999 6.8C10.106 6.8015 10.2113 6.78192 10.3096 6.74238C10.408 6.70285 10.4975 6.64416 10.573 6.56973C10.6485 6.49529 10.7085 6.40659 10.7494 6.30879C10.7903 6.21098 10.8114 6.10602 10.8114 6C10.8114 5.89398 10.7903 5.78902 10.7494 5.69121C10.7085 5.59341 10.6485 5.50471 10.573 5.43027C10.4975 5.35584 10.408 5.29715 10.3096 5.25762C10.2113 5.21809 10.106 5.1985 9.99999 5.2C4.85474 5.2 6.65099 5.2 1.99999 5.2Z"
        className={`${disabled ? "fill-gray3" : "fill-current"}`}
      />
    </svg>
  );
};

export default SvgMinus;
